import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import { SpaciousSemantic_getInstance49m8xgr9xadn as SpaciousSemantic_getInstance } from '../../theme/semantics.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  CardSemantic_getInstancelcny5le8pbc4 as CardSemantic_getInstance,
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  HeaderSemantic_getInstance20a9id3sf7d4x as HeaderSemantic_getInstance,
  get_H2Semantic1i9pxrezr3hyb as get_H2Semantic,
  ButtonSemantic_getInstance3q30xblp6a1af as ButtonSemantic_getInstance,
  ImportantSemantic_getInstancehm7lt56tp87l as ImportantSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { CareProvider2qcawrqluyllr as CareProvider } from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_name27z06mu1petol as get_name,
  get_vendorNumber1lzwv828k7xtu as get_vendorNumber,
  get_offersTransportation17zpg1z1kf9iz as get_offersTransportation,
  get_contact2nyc8wbyivmn as get_contact,
  get_name1iemflb9d8z7b as get_name_0,
  get_emailbv7cfcsvgkdr as get_email,
  get_phone31swsuqbmo9e as get_phone,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import { lensPath21i5dxhjzuxep as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  LabeledView$_get_content_$ref_5yojet1mvh3jfqyuzca as LabeledView$_get_content_$ref_5yojet,
  LabeledView$_set_content_$ref_ys1c8fi8j7ehqqddvg as LabeledView$_set_content_$ref_ys1c8f,
} from '../LoginScreen.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { nullToBlank2cwx9yazfqg5v as nullToBlank } from '../../../../../../reactive/com/lightningkite/reactive/extensions/commonLenses.mjs';
import {
  labeledCheckbox2i8m4uxe4r9p8 as labeledCheckbox,
  get_standardDialogWidth1plathvfuoe55 as get_standardDialogWidth,
} from '../components/view-utilities.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  TextView$_get_content_$ref_4pzcwl5a4gnldk8ef9 as TextView$_get_content_$ref_4pzcwl,
  TextView$_set_content_$ref_pketfb11e282hr0m0jl as TextView$_set_content_$ref_pketfb,
} from '../../App.mjs';
import {
  withStringBufferw9sv07w4j3wo as withStringBuffer,
  withStringBuffer3khj76irczpue as withStringBuffer_0,
} from '../components/validation.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints19w9rda6g3rqz as sizeConstraints,
  get_scrolling3fwkltztkpfe8 as get_scrolling,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Separator36hc2oubnyjy3 as Separator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Separator.commonHtml.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick3gjrd4jjo1cak as onClick } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { weight31wqab1913ly4 as weight } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { Action2nhdpxpznfsbd as Action } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/Action.mjs';
import {
  dialog3sxbjr735jrum as dialog,
  toast4hp3bb4ymp24 as toast,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/popoverHelpers.mjs';
import { AppState_getInstance33x03n2an9aul as AppState_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/reactive/AppState.js.mjs';
import { get_stringsy7vodl9dj0ya as get_strings } from '../../strings.mjs';
import {
  orPromise1iucc2to2udt2 as orPromise,
  $3l5vvh8yg0ier as $,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import {
  await1uwe8zvsjq69o as await_0,
  await1xlt6i5aa076q as await_1,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function providerForm(form, _this__u8e3s4, provider, withCards) {
  // Inline function 'kotlin.with' call
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (RowOrCol())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  element.set_vertical_nuap32_k$(true);
  if (!withCards) {
    element.set_themeChoice_py59um_k$(element.get_themeChoice_22tyn3_k$().plus_duvq05_k$(SpaciousSemantic_getInstance()));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_0 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_0);
  element.willAddChild_hz2iwc_k$(element_0);
  element_0.set_vertical_nuap32_k$(true);
  if (withCards) {
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(CardSemantic_getInstance()));
  }
  var tmp = providerForm$lambda;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$12);
  var tmp$ret$13 = get_name(it);
  var tmp$ret$10 = lensPath(provider, tmp$ret$13);
  form.stringField$default_pwglgw_k$(element_0, tmp, assertNotBlank(tmp$ret$10), true);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_1 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_0.get_context_h02k06_k$());
  ensureOutermostElement(element_1);
  element_0.willAddChild_hz2iwc_k$(element_1);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = LabeledView$_get_content_$ref_5yojet(element_1);
  var tmp_3 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, LabeledView$_set_content_$ref_ys1c8f(element_1));
  element_1.invoke_bnq13k_k$(tmp_3, providerForm$lambda_0);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_0 = themed(element_1, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_2 = new (TextInput())(this_0.get_context_h02k06_k$());
  ensureOutermostElement(element_2);
  this_0.willAddChild_hz2iwc_k$(element_2);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_4 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
  var tmp$ret$23 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$23);
  var tmp$ret$24 = get_vendorNumber(it_0);
  var tmp$ret$21 = lensPath(provider, tmp$ret$24);
  element_2.bind_gesskf_k$(element_2.content_1, nullToBlank(validated(tmp$ret$21)));
  element_2.onStartup_vrxh3i_k$();
  this_0.addChild_2qpft2_k$(element_2);
  element_1.onStartup_vrxh3i_k$();
  element_0.addChild_2qpft2_k$(element_1);
  var tmp_5 = providerForm$lambda_1;
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_6 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
  var tmp$ret$27 = isInterface(tmp_6, KSerializer()) ? tmp_6 : THROW_CCE();
  var it_1 = new (DataClassPathSelf())(tmp$ret$27);
  var tmp$ret$28 = get_offersTransportation(it_1);
  var tmp$ret$25 = lensPath(provider, tmp$ret$28);
  labeledCheckbox(element_0, tmp_5, tmp$ret$25);
  element_0.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_0);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_3 = new (RowOrCol())(element.get_context_h02k06_k$());
  ensureOutermostElement(element_3);
  element.willAddChild_hz2iwc_k$(element_3);
  element_3.set_vertical_nuap32_k$(true);
  if (withCards) {
    element_3.set_themeChoice_py59um_k$(element_3.get_themeChoice_22tyn3_k$().plus_duvq05_k$(CardSemantic_getInstance()));
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_4);
  element_3.willAddChild_hz2iwc_k$(element_4);
  element_4.set_themeChoice_py59um_k$(element_4.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
  var tmp_7 = KMutableProperty0();
  var tmp_8 = TextView$_get_content_$ref_4pzcwl(element_4);
  var tmp_9 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb(element_4));
  element_4.invoke_bnq13k_k$(tmp_9, providerForm$lambda_2);
  element_4.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_4);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_5);
  element_3.willAddChild_hz2iwc_k$(element_5);
  var tmp_10 = KMutableProperty0();
  var tmp_11 = LabeledView$_get_content_$ref_5yojet(element_5);
  var tmp_12 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, LabeledView$_set_content_$ref_ys1c8f(element_5));
  element_5.invoke_bnq13k_k$(tmp_12, providerForm$lambda_3);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_1 = themed(element_5, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_6 = new (TextInput())(this_1.get_context_h02k06_k$());
  ensureOutermostElement(element_6);
  this_1.willAddChild_hz2iwc_k$(element_6);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_13 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
  var tmp$ret$47 = isInterface(tmp_13, KSerializer()) ? tmp_13 : THROW_CCE();
  var it_2 = new (DataClassPathSelf())(tmp$ret$47);
  var tmp$ret$48 = get_name_0(get_contact(it_2));
  var tmp$ret$45 = lensPath(provider, tmp$ret$48);
  element_6.bind_gesskf_k$(element_6.content_1, tmp$ret$45);
  element_6.onStartup_vrxh3i_k$();
  this_1.addChild_2qpft2_k$(element_6);
  element_5.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_5);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_7 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_7);
  element_3.willAddChild_hz2iwc_k$(element_7);
  var tmp_14 = KMutableProperty0();
  var tmp_15 = LabeledView$_get_content_$ref_5yojet(element_7);
  var tmp_16 = getPropertyCallableRef('content', 0, tmp_14, tmp_15, LabeledView$_set_content_$ref_ys1c8f(element_7));
  element_7.invoke_bnq13k_k$(tmp_16, providerForm$lambda_4);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
  var this_2 = themed(element_7, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_8 = new (TextInput())(this_2.get_context_h02k06_k$());
  ensureOutermostElement(element_8);
  this_2.willAddChild_hz2iwc_k$(element_8);
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_17 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
  var tmp$ret$58 = isInterface(tmp_17, KSerializer()) ? tmp_17 : THROW_CCE();
  var it_3 = new (DataClassPathSelf())(tmp$ret$58);
  var tmp$ret$59 = get_email(get_contact(it_3));
  var tmp$ret$56 = lensPath(provider, tmp$ret$59);
  element_8.bind_gesskf_k$(element_8.content_1, withStringBuffer(validated(tmp$ret$56)));
  element_8.onStartup_vrxh3i_k$();
  this_2.addChild_2qpft2_k$(element_8);
  element_7.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_7);
  // Inline function 'com.lightningkite.kiteui.views.l2.label' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_9 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(element_3.get_context_h02k06_k$());
  ensureOutermostElement(element_9);
  element_3.willAddChild_hz2iwc_k$(element_9);
  var tmp_18 = KMutableProperty0();
  var tmp_19 = LabeledView$_get_content_$ref_5yojet(element_9);
  var tmp_20 = getPropertyCallableRef('content', 0, tmp_18, tmp_19, LabeledView$_set_content_$ref_ys1c8f(element_9));
  element_9.invoke_bnq13k_k$(tmp_20, providerForm$lambda_5);
  // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
  // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
  var this_3 = themed(element_9, FieldSemantic_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element_10 = PhoneNumberInput().new_com_lightningkite_kiteui_views_direct_PhoneNumberInput_w1yrw4_k$(this_3.get_context_h02k06_k$());
  ensureOutermostElement(element_10);
  this_3.willAddChild_hz2iwc_k$(element_10);
  var tmp_21 = element_10.get_content_h02jrk_k$();
  // Inline function 'com.lightningkite.serialization.lensPath' call
  // Inline function 'com.lightningkite.services.database.path' call
  // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
  var tmp_22 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
  var tmp$ret$69 = isInterface(tmp_22, KSerializer()) ? tmp_22 : THROW_CCE();
  var it_4 = new (DataClassPathSelf())(tmp$ret$69);
  var tmp$ret$70 = get_phone(get_contact(it_4));
  var tmp$ret$67 = lensPath(provider, tmp$ret$70);
  element_10.bind_gesskf_k$(tmp_21, withStringBuffer_0(validated(tmp$ret$67)));
  element_10.onStartup_vrxh3i_k$();
  this_3.addChild_2qpft2_k$(element_10);
  element_9.onStartup_vrxh3i_k$();
  element_3.addChild_2qpft2_k$(element_9);
  element_3.onStartup_vrxh3i_k$();
  element.addChild_2qpft2_k$(element_3);
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function addProviderDialog(form, _this__u8e3s4, provider, clearDraft) {
  // Inline function 'kotlin.with' call
  var $this$with = form;
  dialog(_this__u8e3s4, VOID, ($this$dialog, close) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    var this_0 = get_scrolling(sizeConstraints($this$dialog, VOID, VOID, VOID, VOID, VOID, get_standardDialogWidth()));
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element);
    this_0.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.h2' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (TextView())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    element.willAddChild_hz2iwc_k$(element_0);
    element_0.set_themeChoice_py59um_k$(element_0.get_themeChoice_22tyn3_k$().plus_duvq05_k$(HeaderSemantic_getInstance().plus_duvq05_k$(get_H2Semantic())));
    var tmp = KMutableProperty0();
    var tmp_0 = TextView$_get_content_$ref_4pzcwl(element_0);
    var tmp_1 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb(element_0));
    element_0.invoke_bnq13k_k$(tmp_1, addProviderDialog$lambda$lambda);
    element_0.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_0);
    providerForm($this$with, element, provider, false);
    // Inline function 'com.lightningkite.kiteui.views.direct.separator' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Separator())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    element.willAddChild_hz2iwc_k$(element_1);
    element_1.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = new (RowOrCol())(element.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    element.willAddChild_hz2iwc_k$(element_2);
    element_2.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_1 = themed(element_2, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (Button())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_1.willAddChild_hz2iwc_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (TextView())(element_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    element_3.willAddChild_hz2iwc_k$(element_4);
    var tmp_2 = KMutableProperty0();
    var tmp_3 = TextView$_get_content_$ref_4pzcwl(element_4);
    var tmp_4 = getPropertyCallableRef('content', 0, tmp_2, tmp_3, TextView$_set_content_$ref_pketfb(element_4));
    element_4.invoke_bnq13k_k$(tmp_4, addProviderDialog$lambda$lambda_0);
    element_4.onStartup_vrxh3i_k$();
    element_3.addChild_2qpft2_k$(element_4);
    onClick(element_3, VOID, VOID, VOID, addProviderDialog$lambda$slambda(provider, close));
    element_3.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_3);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    var this_2 = weight(element_2, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (Space())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    // Inline function 'com.lightningkite.kiteui.views.important' call
    // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
    var this_3 = themed(element_2, ImportantSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    var this_4 = themed(this_3, ButtonSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Button())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_4.willAddChild_hz2iwc_k$(element_6);
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = new (TextView())(element_6.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    element_6.willAddChild_hz2iwc_k$(element_7);
    var tmp_5 = KMutableProperty0();
    var tmp_6 = TextView$_get_content_$ref_4pzcwl(element_7);
    var tmp_7 = getPropertyCallableRef('content', 0, tmp_5, tmp_6, TextView$_set_content_$ref_pketfb(element_7));
    element_7.invoke_bnq13k_k$(tmp_7, addProviderDialog$lambda$lambda_1);
    element_7.onStartup_vrxh3i_k$();
    element_6.addChild_2qpft2_k$(element_7);
    element_6.set_action_2ds022_k$(Action('Add provider', VOID, VOID, VOID, VOID, VOID, addProviderDialog$lambda$slambda_0(provider, $this$with, element_6, close, clearDraft)));
    element_6.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_6);
    element_2.onStartup_vrxh3i_k$();
    element.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element);
    return Unit_instance;
  });
  return Unit_instance;
}
function providerForm$lambda($this$stringField) {
  return $this$stringField.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerNameLabel_yl378x_k$();
}
function providerForm$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerVendorNumberLabel_cg5mi1_k$();
}
function providerForm$lambda_1($this$labeledCheckbox) {
  return $this$labeledCheckbox.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerOffersTransportationLabel_8w5t13_k$();
}
function providerForm$lambda_2($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactLabel_6n76gi_k$();
}
function providerForm$lambda_3($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactNameLabel_l558ot_k$();
}
function providerForm$lambda_4($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactEmailLabel_lc4wv2_k$();
}
function providerForm$lambda_5($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerContactPhoneLabel_umwegk_k$();
}
function addProviderDialog$lambda$lambda($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerAddDialogHeading_873vsd_k$();
}
function addProviderDialog$lambda$lambda_0($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_crudCancelButton_yk4tir_k$();
}
function addProviderDialog$lambda$slambda($provider, $close) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    $provider.cancel_2l89ey_k$();
    $close();
    return Unit_instance;
  }), 0);
}
function addProviderDialog$lambda$lambda_1($this$invoke) {
  return $this$invoke.invoke_r7m7el_k$(get_strings(AppState_getInstance())).get_providerAddButtonLabel_34jbj9_k$();
}
function addProviderDialog$lambda$slambda_0($provider, $$this$with, $$this$button, $close, $clearDraft) {
  return constructCallableReference(($this$Action, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = get_issues($provider);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!(yield* await_0(this_0, $completion)).isEmpty_y1axqb_k$()) {
      yield* $$this$with.get_showValidation_c0zzxd_k$().set_revjhg_k$(true, $completion);
      return Unit_instance;
    }
    var saved = yield* $provider.publish_xq9q2e_k$($completion);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = get_currentSessionNotNull();
    yield* (yield* await_0(this_1, $completion)).get_careProviders_b5tc2w_k$().add_co22jy_k$(saved, $completion);
    var tmp_0 = $$this$button.get_context_h02k06_k$();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = get_strings(AppState_getInstance());
    var tmp$ret$3 = yield* await_1(this_2, $completion);
    toast(tmp_0, tmp$ret$3.get_providerAddedToast_i8f4wv_k$());
    $close();
    yield* $($clearDraft($completion), $completion);
    return Unit_instance;
  }), 1);
}
//region block: exports
export {
  addProviderDialog as addProviderDialog20a0t0374qw9d,
  providerForm as providerForm1foiubykcediz,
};
//endregion

//# sourceMappingURL=providerComponents.mjs.map
